import axios from 'axios'
import { getAuthHeader } from './config'

const baseURL = '/enrollments'
const prefixURL = '/api'

const getEnrollments = async (courseId) => {
  const response = await axios.get(`${prefixURL}/${courseId}${baseURL}`, getAuthHeader())

  return response.data
}

const updateEnrollment = async (courseId, enrollmentId, enrolledAs) => {
  const response = await axios.post(
    `${prefixURL}/${courseId}${baseURL}`,
    {
      enrollmentId,
      enrolledAs
    },
    getAuthHeader()
  )
  return response.data
}

const enrollmentsService = {
  getEnrollments,
  updateEnrollment
}
export default enrollmentsService
